// extracted by mini-css-extract-plugin
export default {"header":"styles_header__Y3Ppp","pagination":"styles_pagination__pZPOt"};